module.exports = __webpack_public_path__ + "img/icon-sync.504e71f4.svg";